module.exports = __webpack_public_path__ + "img/home_hero_banner.47670913.jpg";